<template>
  <div class="d-flex justify-end mb-6">
    <DocsSideBar v-if="contentFetched"/>
    
    <v-card
      flat
      width="80%"
      class="scroll" 
      height="100%"
    >
      <router-view :key="$route.path" />
    </v-card>
  </div>
</template>

<script>
  import {createClient} from '../plugins/contentful.js'
  import { mapActions } from 'vuex'

  const client = createClient()

  export default {
    components: {
      DocsSideBar: require('@/components/DocsSideBar').default,
    },
    created () {
      console.log('[Documentation] - created...');
      this.asyncData()
    },
    data: () => ({
      contentFetched: false
    }),
    methods: {
      // ...mapMutations({
      //   setEntries: 'contentful/SET_ENTRIES'
      // }),
      ...mapActions({
        setEntries: 'contentful/setEntries'
      }),
      asyncData() {
        console.log('[Documentation] - asyncData...');

        // get all entries
        client.getEntries()
        // .then((response) => console.log(response.items))
        .then((response) => {
          console.log('[Documentation] - asyncData - response: ', response)
            // save on store
            this.setEntries(response.items);
            // this.entries = [...response.items]
            this.contentFetched = true
        })
        .catch(console.error)

        // get overview entrypointconst contentful = require('contentful')
        // client.getEntry('15mPq0Abqq88F0Fr7K6yVN ')
        // .then((entry) => console.log('[Documentation] - asyncData - entry: ', entry))
        // .catch(console.error)
      }
    }
  }
</script>

<style lang="scss" scoped>
  // .scroll {
  //   overflow-y: scroll;
  //   overflow-x: hidden;
  // }
</style>